import { render, staticRenderFns } from "./AuthorizationListContainer.vue?vue&type=template&id=084f771c&scoped=true"
import script from "./AuthorizationListContainer.vue?vue&type=script&lang=js"
export * from "./AuthorizationListContainer.vue?vue&type=script&lang=js"
import style0 from "./AuthorizationListContainer.vue?vue&type=style&index=0&id=084f771c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084f771c",
  null
  
)

export default component.exports